import { Alert, Snackbar, styled, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import brandclub_colors from '../../../colors/brandclubColors';
import { AppImage } from '../../../Components/AppImage';
import { getImageAssetUrl } from '../../../utils/assetUtils';
import { DIALOG_SCREEN_SIZE } from '../../../utils/constants';
import { ButtonName } from '../../../theme';
import { Button } from '../../../Components/Button';

const ShareDialogContentContainer = styled('div', {
  label: 'ShareDialogContentContainer',
})(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: 16,
  '.platform': {
    marginTop: 10,
    width: '100%',
    maxWidth: 335,
    height: 50,
    justifyContent: 'center',
    // gap: 8,
    alignItems: 'center',
    border: `none !important`,
    transition: `background-color 0.3s ease-in-out`,
  },
  'span.platform-title': {
    [`@media (max-width: ${DIALOG_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
  '.link-copied-snackbar': {
    '.MuiPaper-root': {
      fontSize: 16,
      backgroundColor: brandclub_colors.white,
      borderRadius: 12,
      boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.16)',
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
}));

export interface SharePageProps {
  url: string;
  onShareLinkCopied?: () => Promise<void>;
}

export const SharePage = ({ url, onShareLinkCopied }: SharePageProps) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [copyText, setCopyText] = useState('Copy Link');
  const desktopView = useMediaQuery(`(min-width:${DIALOG_SCREEN_SIZE}px)`);
  const handleCopyLink = async () => {
    navigator.clipboard.writeText(url);
    setCopyText('Link copied!');
    if (onShareLinkCopied) {
      await onShareLinkCopied();
    }
  };

  return (
    <ShareDialogContentContainer>
      <Button
        variant="solid"
        color="primary"
        className="platform"
        onClick={handleCopyLink}
        buttonName={ButtonName.ShareDialogButton}
      >
        <span className="platform-title">{copyText}</span>
      </Button>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={(theme) => ({
          boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
          borderRadius: '7px',
          overflow: 'hidden',
          position: desktopView ? 'absolute' : 'fixed',
          bottom: `${desktopView ? '1.5' : '1'}% !important`,
          backgroundColor: theme.vars.palette.background.default,
        })}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          severity="success"
          icon={
            <AppImage
              src={getImageAssetUrl('icon_success_tick.webp')}
              alt="icon-success-tick"
              style={{ maxWidth: '20px' }}
            />
          }
          sx={(theme) => ({
            backgroundColor: theme.vars.palette.background.default,
            boxShadow: 'none',
            color: theme.vars.palette.text.primary,
            fontSize: 12,
            fontWeight: 600,
          })}
        >
          Link copied
        </Alert>
      </Snackbar>
    </ShareDialogContentContainer>
  );
};
